import { useScreenContext } from '@omni/kit/contexts/ScreenContext';
import LottieView, { LottieViewProps } from '@omni/kit/lottie';
import { getSpacing } from '@omni/kit/theming/SpacingType';
import React, { ReactElement } from 'react';
import { FlexAlignType, View } from 'react-native';

import { IBlockProps } from '../types';

const debug = require('debug')('tca:blocks:LottieBlock');

export interface LottieBlockProps extends IBlockProps {
  align?: 'center' | 'start' | 'end';
  height?: number | `${number}%`;
  /** https://github.com/lottie-react-native/lottie-react-native/blob/master/docs/api.md */
  lottieProps: LottieViewProps;
}

/** Added in release 6.15.0 */
export default function LottieBlock(
  props: LottieBlockProps
): ReactElement | null {
  const {
    align = 'center',
    bottomSpacing = null,
    height = 100,
    horizontalSpacing,
    lottieProps,
    topSpacing = null,
  } = props;

  const { edgeSpacing, viewPortHeight } = useScreenContext({
    fixedSpacingType: horizontalSpacing,
  });

  const viewStyle = {
    marginTop: getSpacing(topSpacing),
    marginBottom: getSpacing(bottomSpacing),
    marginHorizontal: edgeSpacing,
  };

  let viewHeight = 0;

  if (typeof height === 'string' && height.endsWith('%')) {
    const percentage = parseInt(height.slice(0, -1), 10);

    if (!isNaN(percentage)) {
      viewHeight = viewPortHeight * (percentage / 100);
    }
  } else {
    viewHeight = height as number;
  }

  const alignItemsOpt: Record<string, FlexAlignType> = {
    center: 'center',
    start: 'flex-start',
    end: 'flex-end',
  };

  return (
    <View
      style={{
        ...viewStyle,
        height: viewHeight,
        alignItems: alignItemsOpt[align],
      }}
    >
      <LottieView
        style={{
          height: '100%',
          aspectRatio: 1,
        }}
        {...lottieProps}
      />
    </View>
  );
}
